import type { TDetectionRect } from '@vlabs/monokit/entities/matcher/types/types';

export interface TransformEstimationArgument {
  face: {
    detection: {
      attributes: {
        descriptor: {
          score: number;
          sdk_descriptor: string;
        };
      };
      image: string;
      rect: TDetectionRect;
      warp: string;
    };
  };
  body: {
    detection: {
      attributes: {
        descriptor: {
          score: number;
          sdk_descriptor: string;
        };
      };
      image: string;
      rect: TDetectionRect;
      warp: string;
    };
  };
}

interface TDetection {
  type: 'face' | 'body';
  warp: string;
  rect: TDetectionRect;
  id: string;
  image: string;
  attributes: {
    descriptor: {
      score: number;
      sdk_descriptor: string;
    };
  };
}

interface TransformEstimationReturn {
  faces: TDetection[];
  bodies: TDetection[];
}

const transformEstimation = (estimations: TransformEstimationArgument[]): TransformEstimationReturn => {
  return {
    faces: estimations
      .filter(({ face }) => face)
      .map(({ face }, i) => ({
        type: 'face',
        id: `face${i}`,
        ...face?.detection,
      })),
    bodies: estimations
      .filter(({ body }) => body)
      .map(({ body }, i) => ({
        type: 'body',
        id: `body${i}`,
        ...body?.detection,
      })),
  };
};

export interface FromApiReturn {
  all: (TDetection & { image: string })[];
  byId: Record<string, TDetection>;
  faces: TDetection[];
  bodies: TDetection[];
}

export const fromAPI = (rawEstimations: TransformEstimationArgument[]): FromApiReturn => {
  const estimations = transformEstimation(rawEstimations);

  const rawAll: TDetection[] = [...estimations.faces, ...estimations.bodies];

  const all = rawAll.map((detection) => ({
    ...detection,
    image: `data:image/jpeg;base64,${detection.warp}`,
  }));

  const byId: Record<string, TDetection> = {};
  all.forEach((d) => {
    byId[d.id] = d;
  });

  return {
    all,
    byId,
    bodies: all.filter(({ type }) => type === 'body'),
    faces: all.filter(({ type }) => type === 'face'),
  };
};
